import { useEffect, useMemo, useRef, useState } from "react";
import AddProva from "./AddProva";
import Prova from "./Prova";
import styles from "./Prova.styles";

import Styled from "styled-components"

import List from '../../../utils/draggable-list/index.js'
import moment from 'moment'
import { fetchAPI, postAPI, applyTimeZone } from "../../../utils/utils";
import Pressable from "../../other/Pressable.js";
import PaperBin from "./PaperBin";
import { createOrderEditTracker, describeMove, postOrderEdit } from "./orderEdits";
import ModelFolderBrowser from "./ModelFolderBrowser";
import useProvesFetes from "./useProvesFetes";
import { getFolderProves } from "./modelFolders";
import { can, isTecnica, isHeadTecnica } from "../../../utils/permissions";

function HoraInici({ userInfo, socket, event, horaInici, setHoraInici }) {
    const askHora = () => {
        const promptedHora = prompt(
            "Tria l'hora d'inici de les proves",
            horaInici.format('HH:mm')
        )

        if (promptedHora === null) return;

        const horaValid = moment(promptedHora, "HH:mm", true).isValid()
        if (!horaValid) {
            alert("L'hora introduïda no és vàlida. Si us plau, introdueix-la en el següent format: 'HH:MM'. Exemples: 19:24, 05:42, 00:59...")
            return;
        }

        const [HH, MM] = promptedHora.split(':');
        
        // Create a new moment object based on the current horaInici date
        const newHoraInici = moment(horaInici)
        newHoraInici.set({ hour: parseInt(HH), minute: parseInt(MM) })
        
        // Update state
        setHoraInici(newHoraInici)

        // Emit socket events
        socket.emit('.save_horainici', event, newHoraInici.toDate())
        socket.emit('.request_hores_proves', event)
    }

    return (
        <div
            style={{...styles.prova, ...{ display: 'flex', justifyContent: 'space-around' }}}
        >
            <div style={{ flex: 3, display: 'flex', justifyContent: 'center' }}>
                INICI PROVES
            </div>

            <div style={{ flex: 1, display: 'flex', justifyContent: 'center', gap: 10 }}>
                <div style={{ color: "#2859A8" }}>
                    {horaInici.format('HH:mm')}
                </div>
                {
                    can(userInfo, 'EDIT_HORA_PROVES') && (
                        <a href='#' onClick={askHora} style={{ color: "#2859A8" }}>
                            &#x270E;
                        </a>
                    )
                }
            </div>
        </div>
    )
}

export const calculateProvesHores = (proves, order, durations, horaInici, absolute=false) => {
    const DEFAULT_DURATION = 10

    // Format durations if it's a string
    if (durations && typeof durations === 'string') {
        const formattedDurations = {};
        const lines = durations.split('\n');
        
        for (const line of lines) {
            if (line.includes('=')) {
                const [key, value] = line.split('=');
                if (key && value) {
                    formattedDurations[key] = parseInt(value) || DEFAULT_DURATION;
                }
            }
        }
        
        durations = formattedDurations;
    }

    let all_names = []
    if ('public' in proves && 'private' in proves && 'admin' in proves) all_names = [...proves.public, ...proves.private, ...proves.admin]
    else all_names = [...proves]

    const orderWithKnownCastells = [...new Set((order || [])
        .filter(castell => all_names.includes(castell)))]

    const itemOrder = orderWithKnownCastells
        .map(castell => all_names.indexOf(castell))

    const itemOrderFull = [
        ...itemOrder,
        ...all_names
            .map((castell, i) => i)
            .filter(idx => !orderWithKnownCastells.includes(all_names[idx]))
    ]

    const orderDurations = itemOrderFull
        .map(i => all_names[i])
        .map(fullName => fullName.split('.')[0] || '')
        .map(castell => {
            // Check if durations is an object and handle if it's not
            if (!durations || typeof durations !== 'object') {
                console.error('Invalid durations format:', durations);
                return DEFAULT_DURATION;
            }
            return castell in durations ? durations[castell] : DEFAULT_DURATION;
        })

    const compoundDurations = (hora => duration =>
        [
            hora.clone(),
            hora.add(duration, 'minutes').clone()
        ]
    )(horaInici.clone())

    const hores = orderDurations
        .map(compoundDurations)
    
    return absolute ? hores : hores.map(hora => hora.map(h => h.format('HH:mm')))
}

function DragHandle(props) {
    const { hores, disabled, isModels, ...handleProps } = props;

    if (isModels) return <div {...handleProps} style={{ padding: 6, cursor: disabled ? 'default' : 'grab' }} aria-label="Mou per reordenar">↕</div>;

    return (
        <div {...props} style={{ display: 'flex', justifyContent: 'space-evenly', flex: 1 }}>
            <div style={{ color: 'gray', fontSize: 12 }}>
                <div style={{ cursor: !disabled ? 'pointer' : 'default' }}>{hores[0]}</div>
                <div style={{ cursor: !disabled ? 'pointer' : 'default' }}>{hores[1]}</div>
            </div>
        </div>
    )
}

const provaItemStyles = ['white', 'rgb(235,235,235)', 'rgb(235,200,200)', 'rgb(230,150,150)'].map(background => Styled.div`
    background-color: ${background};
    padding: 10px;
    border-radius: 5px;
    flex: 1;
    text-align: center;
    font-size: 16px;
    display: flex;
    justify-content: space-around;
    align-items: center;
`);
const ProvaItem = (isNeta, isAdmin) => provaItemStyles[Number(isNeta) + 2 * Number(isAdmin)];



function LlistaProves(props) {
    const { allPosicions, setAllPosicions, bundlesInfo, proves, setProves, horaInici, setHoraInici, assistencies, setAssistencies, order, setOrder, socket, event, durations, setDurations, userInfo } = props;
    // Mentre hi ha canvis propis en camí, els ordres que arriben d'un altre lloc esperen
    const orderEdits = useRef(createOrderEditTracker());
    const { modelFolders } = props;
    const [selectedModels, setSelectedModels] = useState([]);
    const [openModelMenu, setOpenModelMenu] = useState(null);
    const defaultHoraInici = applyTimeZone(props['data-inici'])
    const [editing, setEditing] = useState(false)
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768)
    const [labels, setLabels] = useState({})
    const showPrivateLabels = isTecnica(userInfo)

    useEffect(() => { setSelectedModels([]); setEditing(false); }, [modelFolders?.folderId]);

    // Proves ja fetes (compartit amb l'app a través de `.proves_fetes`)
    const { fetes, toggleFeta } = useProvesFetes({ socket, event, enabled: !props.isModels, userId: userInfo?.id || null });

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768)
        }
        
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    useEffect(() => {
        const refreshProves = () => fetchAPI(`/proves/${event}`, res => setProves(res), false);
        const refreshOrder = () => fetchAPI(`/order/${event}`, res => setOrder(res), false);
        const onConnect = () => {
            refreshProves();
            refreshOrder();
        };
        fetchAPI(`/horainici/${event}`, data => setHoraInici(moment(data)))
        fetchAPI(`/assistencies_event/${event}`, data => setAssistencies(data.data))
        refreshOrder();
        refreshProves();
        if (showPrivateLabels) fetchAPI(`/prova_labels/${event}`, data => setLabels(data))
        else setLabels({})

        const onAssistencies = data => data.event === event ? setAssistencies(data.data) : false;
        // The event card's only copy of the attendance (its summary reads it too): keep it live
        const onConfirmat = res => {
            if (res.event === event) fetchAPI(`/assistencies_event/${event}`, data => setAssistencies(data.data), false)
        };
        const onNewOrder = (ev, ord) => {
            if (event === ev) {
                fetchAPI(`/proves/${event}`, res => setProves(res), false)
                if (orderEdits.current.incoming()) setOrder(ord)
            }
        };

        const onChangedState = (evId, castell, versio, old_state, new_state) => {
            if (parseInt(event) === parseInt(evId) && old_state !== new_state) {
                setProves(prev => {
                    if (old_state in prev) {
                        return {
                            ...prev,
                            [old_state]: prev[old_state].filter(p => p !== `${castell}.${versio}.canvis`),
                        }
                    }
                    return prev;
                });
                setProves(prev => {
                    if (new_state in prev) {
                        return {
                            ...prev,
                            [new_state]: [...prev[new_state], `${castell}.${versio}.canvis`],
                        }
                    }
                    return prev;
                });
            }
        };

        const onDeleted = (evId, castell, versio) => {
            if (parseInt(event) === parseInt(evId)) {
                setProves(prev => {
                    return {
                        ...prev,
                        admin: prev.admin.filter(p => p !== `${castell}.${versio}.canvis`),
                        public: prev.public.filter(p => p !== `${castell}.${versio}.canvis`),
                        private: prev.private.filter(p => p !== `${castell}.${versio}.canvis`),
                    }
                })
                fetchAPI(`/proves/${event}`, res => setProves(res), false)
            }
        };

        const onRestored = (evId, castell, versio) => {
            if (parseInt(event) === parseInt(evId)) {
                // Fetch updated proves list
                fetchAPI(`/proves/${event}`, res => setProves(res), false);
                
                // Add the restored prova to the order if it's not already there
                const fullName = `${castell}.${versio}.canvis`;
                setOrder(previous => previous.includes(fullName) ? previous : [...previous, fullName]);
            }
        };

        const onModelsChanged = evId => {
            if (String(event) !== String(evId)) return;
            onConnect();
            if (showPrivateLabels) fetchAPI(`/prova_labels/${event}`, data => setLabels(data), false);
        };
        socket.on('.model_folders_updated', onModelsChanged);
        socket.on('connect', onConnect);
        socket.on('.assistencies_event', onAssistencies);
        socket.on('.confirmat', onConfirmat);
        socket.on('.new_order', onNewOrder);
        socket.on('.changed_state_prova', onChangedState);
        socket.on('.deleted_prova', onDeleted);
        socket.on('.restored_prova', onRestored);

        return () => {
            socket.off('.model_folders_updated', onModelsChanged);
            socket.off('connect', onConnect);
            socket.off('.new_order', onNewOrder);
            socket.off('.assistencies_event', onAssistencies);
            socket.off('.confirmat', onConfirmat);
            socket.off('.changed_state_prova', onChangedState);
            socket.off('.deleted_prova', onDeleted);
            socket.off('.restored_prova', onRestored);
        }
    }, [event, showPrivateLabels, socket]);

    useEffect(() => {
        durations.length > 0 && all_names
            .filter(fullName => fullName.split('.').length > 0)
            .map(fullName => fullName.split('.')[0])
            .filter(prova => !(prova in durations))
            // Add default 15 minuts to each unknown prova
            .forEach(prova => socket.emit('.edit_duration', prova, 15))
    }, [proves, durations])

    const check_duplicate = (prova, proves) => {
        const all_proves = [...proves.public, ...proves.private, ...proves.admin];
        if (prova.split('.').length < 2) return 0;

        const altres_versions = all_proves
            .filter(p => p !== prova)
            .filter(p => p.split('.').length > 1)
            .filter(p => p.split('.')[0] === prova.split('.')[0]);

        return altres_versions.length > 0;
    }

    const canSeeAdminProves = isHeadTecnica(userInfo);
    const canSeePrivateProves = isTecnica(userInfo);

    const folderData = modelFolders?.data;
    const folderId = modelFolders?.folderId;
    const all_names = useMemo(() => {
        const visible = canSeeAdminProves ? [...proves.public, ...proves.private, ...proves.admin] :
            canSeePrivateProves ? [...proves.public, ...proves.private] :
            [...proves.public];
        return props.isModels ? (folderData ? getFolderProves(visible, folderData.items, folderId) : []) : visible;
    }, [canSeeAdminProves, canSeePrivateProves, proves, props.isModels, folderData, folderId]);
    useEffect(() => {
        setSelectedModels(prev => prev.filter(name => all_names.includes(name)));
    }, [all_names]);

    const orderWithKnownCastells = [...new Set((order || [])
        .filter(castell => all_names.includes(castell)))]

    const itemOrder = orderWithKnownCastells
        .map(castell => all_names.indexOf(castell))

    const itemOrderFull = [
        ...itemOrder,
        ...all_names
            .map((castell, i) => i)
            .filter(idx => !orderWithKnownCastells.includes(all_names[idx]))
    ]

    const setItemOrder = newItemOrder => {
        const new_order = newItemOrder.map(idx => all_names[idx])
        if (modelFolders) {
            modelFolders.mutate('order', { folderId: modelFolders.folderId, proves: new_order })
                .then(result => setOrder(result.order)).catch(() => {});
            return;
        }
        setOrder(new_order)
        // El servidor aplica el moviment sobre l'ordre que té ara; si falla, es torna a demanar
        const move = describeMove(itemOrderFull.map(idx => all_names[idx]), new_order)
        if (!move) return sendWholeOrder(new_order)
        orderEdits.current.start()
        postOrderEdit({
            event, edit: { op: 'move', ...move }, socket, userId: userInfo?.id,
            onOrder: result => {
                const { apply, refresh } = orderEdits.current.finish(result)
                if (apply) setOrder(apply)
                if (refresh) refreshOrder()
                socket.emit('.request_hores_proves', event)
            },
            onUnsupported: () => { orderEdits.current.finish(); sendWholeOrder(new_order) },
            onFailure: () => { orderEdits.current.finish(); refreshOrder() },
        })
    }

    // Servidors d'abans de /order_edit
    const sendWholeOrder = new_order => {
        socket.emit('.change_order', event, new_order, userInfo?.id || null)
        socket.emit('.request_hores_proves', event)
    }

    const refreshOrder = () => fetchAPI(`/order/${event}`, res => setOrder(res), false)

    const moveItemUp = (index) => {
        if (index <= 0) return
        const newOrder = [...itemOrderFull]
        const tempIndex = newOrder[index]
        newOrder[index] = newOrder[index - 1]
        newOrder[index - 1] = tempIndex
        setItemOrder(newOrder)
    }

    const moveItemDown = (index) => {
        if (index >= itemOrderFull.length - 1) return
        const newOrder = [...itemOrderFull]
        const tempIndex = newOrder[index]
        newOrder[index] = newOrder[index + 1]
        newOrder[index + 1] = tempIndex
        setItemOrder(newOrder)
    }

    const hores = calculateProvesHores(proves, order, durations, horaInici)
    const absoluteHores = calculateProvesHores(proves, order, durations, horaInici, true)
    const isNeta = prova => {
        const matchedBundle = bundlesInfo
            .find(b => b.id === (prova.split('.')[0] || ''))
        
        if (!matchedBundle) return false;

        const parts = Object.keys(matchedBundle?.parts || {})
            .map(part => part.toLowerCase())
            .filter(part => ['pinya', 'folre', 'manilles', 'puntals', 'tronc'].includes(part))

        return parts
            .every(part => part === 'tronc')
    }

    return (
        <div style={styles.proves}>
            {modelFolders && <ModelFolderBrowser models={modelFolders} userInfo={userInfo} visibleNames={all_names} selected={selectedModels} setSelected={setSelectedModels} />}
            { !props.isModels && <HoraInici socket={socket} event={event} horaInici={horaInici} setHoraInici={setHoraInici} userInfo={userInfo} /> }

            {(!props.isModels || (can(userInfo, 'EDIT_PROVA') && all_names.length > 1)) && <div style={{ display: 'flex', flexDirection: 'row', gap: 5, marginBottom: 10, backgroundColor: '#eee' }}>
                <Pressable style={{ flex: 4, backgroundColor: '#4A90E2', color: 'white', padding: 10, borderRadius: 5, textAlign: 'center', fontSize: 14, border: 'solid 1px transparent' }} onClick={() => setEditing(!editing)}>{editing ? 'Fet' : 'Editar l\'ordre de les proves'}</Pressable>
                { editing && !props.isModels && <Pressable style={{ flex: 1, backgroundColor: '#ddd', color: 'black', padding: 10, borderRadius: 5, textAlign: 'center', fontSize: 14, border: 'solid 1px black' }} onClick={() => socket.emit('.remove_last_order', event)}>&#10554;</Pressable> }
            </div>}

            { all_names.length > 0 &&
                <List
                    rowHeight={props.isModels && isMobile ? 96 : 70}
                    order={itemOrderFull}
                    onReOrder={setItemOrder}
                >{
                    all_names.map((prova, i) => {
                        const currentIndex = itemOrderFull.indexOf(i)
                        return <List.Item
                            key={`item-${event}-${prova}-${proves.admin.includes(prova)}`}
                            className={props.isModels && openModelMenu === prova ? 'model-prova-menu-open' : undefined}
                            as={ProvaItem(isNeta(prova), proves.admin.includes(prova))}
                            dragHandle={
                                <DragHandle
                                    isModels={props.isModels}
                                    hores={hores[itemOrderFull.indexOf(i)] || ['?', '?']}
                                />
                            }
                            disabled={!editing || modelFolders?.busy}
                        >
                            {
                                !editing && !props.isModels && (
                                    <DragHandle
                                        hores={hores[itemOrderFull.indexOf(i)] || ['?', '?']}
                                        disabled={true}
                                    />
                                )
                            }
                            {modelFolders && !(editing && isMobile) && can(userInfo, 'EDIT_PROVA') && <label className="model-folder-select">
                                <input type="checkbox" aria-label={`Selecciona ${bundlesInfo.find(b => b.id === prova.split('.')[0])?.nom || prova}${labels[prova] ? ` (${labels[prova]})` : ''}`}
                                    checked={selectedModels.includes(prova)} disabled={modelFolders.busy || editing}
                                    onChange={e => setSelectedModels(prev => e.target.checked ? [...prev, prova] : prev.filter(name => name !== prova))} />
                            </label>}
                            <Prova
                                hores={hores[itemOrderFull.indexOf(i)] || ['?', '?']}
                                absoluteHores={absoluteHores[itemOrderFull.indexOf(i)] || ['?', '?']}
                                horaInici={horaInici}
                                duplicate={check_duplicate(prova, proves)}
                                key={`prova-${event}-${prova}`}
                                prova={prova}
                                isPrivate={proves.private.includes(prova)}
                                isAdmin={proves.admin.includes(prova)}
                                assistencies={assistencies}
                                bundleInfo={bundlesInfo.find(b => b.id === (prova.split('.')[0] || ''))}
                                allPosicions={allPosicions}
                                setAllPosicions={setAllPosicions}
                                editing={editing && isMobile}
                                labels={showPrivateLabels ? labels : {}}
                                setLabels={setLabels}
                                feta={Boolean(fetes[prova])}
                                onToggleFeta={props.isModels || !showPrivateLabels ? null : () => toggleFeta(prova)}
                                {...props}
                                modelMenuOpen={openModelMenu === prova}
                                onModelMenuToggle={open => setOpenModelMenu(previous => open ? prova : previous === prova ? null : previous)}
                            />
                            {editing && isMobile && (
                                <div style={{ 
                                    position: props.isModels ? 'static' : 'absolute',
                                    left: 110, 
                                    height: props.isModels ? 50 : '100%',
                                    display: 'flex', 
                                    flexDirection: 'column', 
                                    justifyContent: 'space-between',
                                    paddingTop: props.isModels ? 0 : 10,
                                    paddingBottom: props.isModels ? 0 : 10
                                }}>
                                    <Pressable
                                        style={{
                                            backgroundColor: '#f0f4f8',
                                            border: '1px solid #d0d0d0',
                                            borderRadius: 5,
                                            width: 50,
                                            height: 30,
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            opacity: currentIndex > 0 ? 1 : 0.5
                                        }}
                                        onClick={() => moveItemUp(currentIndex)}
                                        disabled={currentIndex <= 0}
                                    >
                                        <div style={{
                                            color: '#4A90E2',
                                            fontSize: 16,
                                            fontWeight: 'bold'
                                        }}>
                                            &#9650;
                                        </div>
                                    </Pressable>
                                    <Pressable
                                        style={{
                                            backgroundColor: '#f0f4f8',
                                            border: '1px solid #d0d0d0',
                                            borderRadius: 5,
                                            width: 50,
                                            height: 30,
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            opacity: currentIndex < itemOrderFull.length - 1 ? 1 : 0.5
                                        }}
                                        onClick={() => moveItemDown(currentIndex)}
                                        disabled={currentIndex >= itemOrderFull.length - 1}
                                    >
                                        <div style={{
                                            color: '#4A90E2',
                                            fontSize: 16,
                                            fontWeight: 'bold'
                                        }}>
                                            &#9660;
                                        </div>
                                    </Pressable>
                                </div>
                            )}
                        </List.Item>
                    }
                    )
                }</List>
            }

            { can(userInfo, 'ADD_PROVA') ? <AddProva {...props} /> : null }

            { <PaperBin
                event={event}
                bundlesInfo={bundlesInfo}
                socket={socket}
                setProves={setProves}
                setOrder={setOrder}
                order={order} 
                userInfo={userInfo}
                modelFolders={modelFolders}
            /> }
        </div>
    );
}

export default LlistaProves;
